import { WidgetSettings } from '../shared/models/widget.model';
import { WidgetUIType } from '../shared/models/widget.type';
import { TenantModuleType } from '../shared/models/tenantModuleType';
import { TenantModule } from '../shared/models/tenantModule';

export interface WidgetDefinition {
  type: WidgetUIType;
  name: string;
  description: string;
  icon: string;
  defaultSettings: () => WidgetSettings;
  requiredModule?: TenantModuleType;
}

// The catalog of widgets a user can add to their homepage. New widget types are
// registered here (and given a @case in home-widget-card) — the backend enum is
// the source of truth for which types are valid.
export const WIDGET_REGISTRY: readonly WidgetDefinition[] = [
  {
    type: WidgetUIType.UpcomingTeams,
    name: 'Upcoming Teams',
    description: 'Teams with an upcoming start date, from a saved team view.',
    icon: 'groups',
    defaultSettings: () => ({})
  },
  {
    type: WidgetUIType.RecentlyAccepted,
    name: 'Recently Accepted',
    description: 'People who accepted a seat in the last 30 days.',
    icon: 'how_to_reg',
    defaultSettings: () => ({})
  },
  {
    type: WidgetUIType.RecentFormResponses,
    name: 'Recent Form Responses',
    description: 'Form submission volume over the last few months.',
    icon: 'assignment',
    defaultSettings: () => ({})
  },
  {
    type: WidgetUIType.InProgressCredentialApplications,
    name: 'Recently Updated Applications',
    description: 'Credential applications updated in the last 30 days, from a saved view.',
    icon: 'badge',
    defaultSettings: () => ({}),
    requiredModule: TenantModuleType.Credentials
  },
  {
    type: WidgetUIType.LatestFormSubmissions,
    name: 'Latest Form Submissions',
    description: 'Form submissions from the last 30 days, optionally scoped to one form.',
    icon: 'assignment_turned_in',
    defaultSettings: () => ({})
  }
];

export function getWidgetDefinition(type: WidgetUIType): WidgetDefinition | undefined {
  return WIDGET_REGISTRY.find((x) => x.type === type);
}

export function isWidgetModuleEnabled(type: WidgetUIType, modules: TenantModule[]): boolean {
  const requiredModule = getWidgetDefinition(type)?.requiredModule;
  return !requiredModule || (modules ?? []).some((m) => m.moduleType === requiredModule);
}
